import { defineStore } from 'pinia'
import { useSpotStore } from '~/store/spot'

export const usePanelStore = defineStore('spotPanel', {
  state: () => ({
    side: 'BUY', // BUY | SELL
    orderType: 'LIMIT', // LIMIT | MARKET
    priceType: 'DEFAULT', // 默认-DEFAULT、对手价-CP、排队价-QP
    price: '', // 价格
    amount: '', // 成交额
    qty: '', // 基础币数量
    slider: 0,

  }),
  getters: {
    isBuy() {
      return this.side === 'BUY'
    },
    isDefaultPt() {
      return this.priceType === 'DEFAULT'
    },
    isMarket() {
      return this.orderType === 'MARKET'
    },
    isLimit() {
      return this.orderType === 'LIMIT'
    },
    getPrice() {
      const stop = useSpotStore()
      const { a1 = 0, b1 = 0 } = stop.bbo

      if (this.isMarket || (!this.isMarket && this.priceType === 'CP'))
        return this.isBuy ? a1 : b1

      if (!this.isMarket && this.priceType === 'QP')
        return this.isBuy ? b1 : a1

      return this.price
    },
  },
})
